import MasterTable from "../../views/dashboard/widget/MasterTabel";
import { useGlobalState } from "../../services/hostelConst.js";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getTutorAssignmentList,
  getTutorAssignmentDetails,
  createTutorAssignment,
  updateTutorAssignmentStatus,
  deleteTutorAssignment,
  deleteTutor,
} from "../../services/Academic-Services";
import AddTutorForm from "../../components/FormComponents/AddTutor";
import AddAssignmentForm from "../FormComponents/AddTutorAssignment";
const TutorAssignmentTable = () => {
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
  } = useGlobalState();
  useEffect(() => {
    resetAdvanceFilterData();
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });

    return () => {};
  }, []);

  return (
    <>
      <MasterTable
        getTableData={getTutorAssignmentList}
        deleteRow={deleteTutorAssignment}
        updateStatus={updateTutorAssignmentStatus}
        tab1={"Academic"}
        tab2={"Tutor Assignment"}
        AddForm={AddAssignmentForm}
        actions={{
          status: true,
          edit: true,
          delete: true,
        }}
      />
    </>
  );
};

export default TutorAssignmentTable;
